// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bangladesh from '../_raw/flag/icon_flag_bangladesh.png';

export default () => <img src={Bangladesh} alt="Bangladesh" />;
